import Home from "./components/Home";
import SingleMovie from "./components/SingleMovie";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Error from "./components/Error";
import { AppProvider } from "./context";

function App() {
  return (
    <AppProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/movie/:id" element={<SingleMovie />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
    </AppProvider>
  );
}

export default App;
